import React from 'react';

const TableRow = ({ children, vAlign }) => {
  let stl = {};
  if (vAlign) {
    stl.verticalAlign = vAlign;
  }
  return <tr style={stl}>{children}</tr>;
};

export default TableRow;
